import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IFavoriteDict } from '@models/favorites/IFavoriteDict';
import { IFavoriteDoc } from '@models/favorites/IFavoriteDoc';
import { IFavoriteDocExtended } from '@models/favorites/IFavoriteDocExtended';
import { IFavoriteDocumentColumn } from '@models/favorites/IFavoriteDocumentColumn';

import { IFavoriteReport } from '@models/favorites/IFavoriteReport';
import { favoriteReportParams } from '@utils/favoriteReport';

export class FavoritesService {
    static async reports(): Promise<AxiosResponse<IFavoriteReport[]>> {
        return $api.get('/favorites/reports', { suppressErrorNotification: true });
    }

    static async checkIsFavoriteReport(report: IFavoriteReport): Promise<AxiosResponse<boolean>> {
        return $api.get('/favorites/reports/check', {
            params: favoriteReportParams(report),
            suppressErrorNotification: true,
        });
    }

    static async addReportToFavorites(report: IFavoriteReport): Promise<AxiosResponse<void>> {
        return $api.post('/favorites/reports', report, { suppressErrorNotification: true });
    }

    static async removeReportFromFavorites(report: IFavoriteReport): Promise<AxiosResponse<void>> {
        return $api.delete('/favorites/reports', {
            params: favoriteReportParams(report),
            suppressErrorNotification: true,
        });
    }

    static async documents(): Promise<AxiosResponse<IFavoriteDoc[]>> {
        return $api.get<IFavoriteDoc[]>(`/favorites/documents`);
    }

    static async documentsColumns(): Promise<AxiosResponse<IFavoriteDocumentColumn[]>> {
        return $api.get<IFavoriteDocumentColumn[]>(`/favorites/documents/columns`);
    }

    static async documentsQuery(extraColumnIds: string[]): Promise<AxiosResponse<IFavoriteDocExtended[]>> {
        return $api.post<IFavoriteDocExtended[]>(`/favorites/documents/query`, {
            extraColumnIds,
        });
    }

    static async dictionaries(): Promise<AxiosResponse<IFavoriteDict[]>> {
        return $api.get<IFavoriteDict[]>(`/favorites/dicts`);
    }

    static async checkIsFavoriteDocument(docId: string): Promise<AxiosResponse<boolean>> {
        return $api.get<boolean>(`/favorites/documents/${docId}`);
    }

    static async addDocumentToFavorites(docId: string): Promise<AxiosResponse<boolean>> {
        return $api.post(`/favorites/documents/${docId}`);
    }

    static async removeDocumentFromFavorites(docId: string): Promise<AxiosResponse<boolean>> {
        return $api.delete(`/favorites/documents/${docId}`);
    }

    static async checkIsFavoriteDictionary(dictId: string): Promise<AxiosResponse<boolean>> {
        return $api.get<boolean>(`/favorites/dicts/${dictId}`);
    }

    static async checkIsFavoriteFormDataDictionary(template: string): Promise<AxiosResponse<boolean>> {
        return $api.get<boolean>(`/favorites/formDataDicts/${template}`);
    }

    static async addDictionaryToFavorites(dictId: string): Promise<AxiosResponse<boolean>> {
        return $api.post(`/favorites/dicts/${dictId}`);
    }

    static async addFormDataDictionaryToFavorites(template: string): Promise<AxiosResponse<boolean>> {
        return $api.post(`/favorites/formDataDicts/${template}`);
    }

    static async removeDictionaryFromFavorites(dictId: string): Promise<AxiosResponse<boolean>> {
        return $api.delete(`/favorites/dicts/${dictId}`);
    }

    static async removeFormDataDictionaryFromFavorites(template: string): Promise<AxiosResponse<boolean>> {
        return $api.delete(`/favorites/formDataDicts/${template}`);
    }
}
